import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getDocs, query, where, collection, orderBy, limit, onSnapshot } from "firebase/firestore";
import { db } from "../firebase.js";
import { Helmet } from "react-helmet";
import Loadingimg from '../components_root/loadingimg.jsx';
import Loading_items from "../components_root/loading_items.jsx";
import logo_default from "../assets/logo_default.jpg";
import Slideshow_Viewer from "./slideshow_viewer.js";
import Rating from "../view_root/rating.js";
import { RiShoppingCartLine } from "react-icons/ri";
import { IoIosGitCompare } from "react-icons/io";
import Loading from "../components_root/loading.jsx";
import { CiRead } from "react-icons/ci";
import banner_default from "../assets/banner_default.jpg";
import Saved from "../view_root/saved.js";
import Cookies from "js-cookie";
import { Toast } from "../components_root/ToastContext";
import Add_cart from "../cart_root/add_cart.js";
import HomeSlideshow from "./homeslideshow.js";
import './home.css';
import BrandSlider from "./BrandSlider.jsx";
import Chart_details from "../cart_root/chart_details.jsx";
import { Get_website_information } from "../website_root/get_website_information.js";
export const seo = {
    title: "Aooz.in | Accounting Online Operations Zone",
    description: "AOOZ is a complete accounting software with web and mobile apps. Manage payments, stocks, staff attendance, inventory, and generate online share receipts. A powerful all-in-one platform for businesses.",
    keywords: "AOOZ accounting software, business accounting app, payment management, stock tracking, inventory software, staff attendance system, online share receipt, web accounting app, mobile accounting app",
    url: "https://aooz.in",
    image: "https://aooz.in/assets/logo.png"
};
export default function Home_page() {
  const { Toastshow } = Toast();
  const navigate = useNavigate();
  const [IsLoading2, setIsLoading2] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [brandnamedata, setBrandnameData] = useState([]);
  const [titlemete, setTitlemete] = useState("");
  const [keywordsmete, setKeywordsmete] = useState("");
  const [products_new_data, setProducts_new_data] = useState([]);
  const [vouchersdata, setVouchersdata] = useState([]);
  const [companydata, setCompanydata] = useState([]);
 
  //get company info
  const [websiteinfodata, setwebsiteinfodata] = useState([]);
  useEffect(() => {
    const websiteuid = Cookies.get("website_uid");
    Get_website_information(websiteuid).then((res) => {
      if (res.success) {
        setwebsiteinfodata(res.data || []);
      }
    });
  }, []);

useEffect(() => {
   const select_company_uid = Cookies.get("select_company_uid");
    setIsLoading2(true);

    if (!select_company_uid) {
        console.error("No company selected");
        setIsLoading2(false);
        return;
    }

    // Correct path:
    const productQuery = query(
        collection(db, "companies", select_company_uid, "vouchers"),
         where("paypublic","==",true),
         where("usecase","==",true),
        orderBy("indexnumber", "asc"),
    );

    const unsubscribe = onSnapshot(
        productQuery,
        (snapshot) => {
            const vouchers = snapshot.docs.map((docSnap) => ({
                id: docSnap.id,
                ...docSnap.data(),
            }));
         setVouchersdata(vouchers);
        setIsLoading2(false);
        },
        (error) => {
            console.error("Error fetching vouchers:", error);
            setIsLoading2(false);
        }
    );

    return () => unsubscribe();
}, []);

 
  // const meta = {
  //   title: websiteinfodata.title ,
  //   description:websiteinfodata.description  ,
  //   keywords:websiteinfodata.keywords   ,
  //   image: seo.image,
  //   url: websiteinfodata.domain_registration,
  // };
 const domain = new URL(window.location.href).hostname;
  useEffect(() => {
  if (websiteinfodata?.title) {
    document.title = websiteinfodata.title;
      <link rel="icon" href={websiteinfodata.logo_url } />
  }
}, [websiteinfodata]);
  
  return (
    <div  >
 
{websiteinfodata && (
  <Helmet>
    <title>{websiteinfodata.title || - domain}</title>

    {websiteinfodata.description && (
      <meta name="description" content={websiteinfodata.description} />
    )}
    {websiteinfodata.keywords && (
      <meta name="keywords" content={websiteinfodata.keywords} />
    )}

    <meta property="og:title" content={websiteinfodata.title} />

    {websiteinfodata.description && (
      <meta property="og:description" content={websiteinfodata.description} />
    )}
    {websiteinfodata.logo_url && (
      <meta property="og:image" content={websiteinfodata.logo_url} />
    )}
    {websiteinfodata.domain_registration && (
      <meta property="og:url" content={websiteinfodata.domain_registration} />
    )}
  </Helmet>
)}

      {/* <div >
        <HomeSlideshow slideshow_filedata={review_slideshow_filedata}
          banner_default={banner_default}
          navigate={navigate} />
      </div> */}
      {/* brandname */}
      <div className="container_roots">
        <div className="container_roots m-top m-bottom container_size">
          <br /> 
        
          <div className="ui-grid-home-items">
            {IsLoading2 ? (
              <></>
            ) : vouchersdata.length === 0 ? (
              <div>data not find  {Cookies.get("select_company_uid")}
              <br/> website_uid:{Cookies.get("website_uid")}</div>
            ) : (
              vouchersdata.map((row) => (
                <div className="ui-items items-back items-back shadow hover rounded cursor" onClick={() => navigate("/" + row.voucherid)} key={row.uid}>
                  <img src={row.logo_url || logo_default} alt={row.voucher} className="brand-thumbnail" />
                  <div >
                    <div className="flex p-11 b-bottom">
                      <table>
                        <tr>
                          <td>
                            <span className="text-h2 bold">Amount</span>
                          </td>
                          <td className="text-r">
                            <div className="text-h1 bold">  <span className="text-off text-h1">₹</span>{row.amount || ""}<span className="text-off text-h2">/-</span></div>
                          </td>
                        </tr>
                      </table>



                    </div>
                    <div className="p-11 ">

                      <div className="text-h1 fcap bold">{row.voucher}</div>
                      <div className="text-h3 fcap m-b">{row.description?.substring(0, 200)}</div>
                      {row.child?.dealname && (
                        <div><span className="red text-h3 items-back rounded-sm">{row.child.dealname}</span></div>
                      )}
                    </div>

                  </div>
                </div>
              ))
            )}
          </div>
        </div>
        <br />
      </div>

    </div>
  );
}
